export const USER_INFO = {
  name: "Ranjan",
  fullName: "Ranjan Adhikari",
  tagline: "Every body look to the left...",
  intro: "I share my adventures, photography, and stories from around the world. Join me as I explore new places and create unforgettable memories.",
  profileImage: "https://www.dropbox.com/scl/fi/dvsn8d0ndwssdxmnneyyc/my-selfie.jpg?rlkey=7gajkz3gu7us0bjtkp0tc9eme&st=9jojzs31&dl=0",
  location: "Kathmandu, Nepal",
  email: "adh.ranjan@gmail.com",
  aboutParagraph1: "With 6+ years in software development, I specialize in backend technologies like Node.js and NestJS, always striving for efficient, scalable solutions.",
  aboutParagraph2: "Traveling fuels my creativity, offering fresh perspectives and inspiring both my personal growth and professional work.",
  aboutParagraph3: "When I'm not coding or traveling, I enjoy diving into computer games, exploring new worlds, and sharpening my strategic thinking.",
  interests: ["Travel", "Photography", "Coding", "I Go to gym"],
  stats: {
    Always: "😀",
    "Resolving the merge Conflict": "🤬",
    Likes: "🤬",
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100070361946323",
    github: "https://github.com/adhranjan",
    instagram: "https://www.instagram.com/adh.ranjan/",
    linkedin: "https://www.linkedin.com/in/adh-ranjan/"
  },
  pronounceAs: "https://www.dropbox.com/scl/fi/wxr399kz6au1tgl8sdqmf/ranjan.mp3?rlkey=o35pwa40szuinw9kmkkjastbu&st=wmdr3dna&dl=0",
};

export const APPS = [
  {
    id: "about",
    name: "About Me",
    icon: "User",
    color: "#4285F4", // Google Blue
    description: "Learn about who I am and what I do",
    showOnHome: true,
    isPopular: true,
  },
  {
    id: "tools",
    name: "Developer Tools",
    icon: "🔧",
    color: "#533b9c", // Google Green
    description: "Tools I've used as a developer",
    children: ["privatebin","jenkins", "git","mistakes","redis", "recursive", ],
    showOnHome: true,
  },
  {
    id: "myapps",
    name: "Personal Collection",
    icon: "🧑‍💻",
    color: "#ad8823", // Google Green
    description: "Experiments",
    children: ["lastsphere", "snakeladder"],
    showOnHome: true,
  },
    {
    id: "lastsphere",
    name: "Last Sphere",
    icon: "Zap",
    color: "#af339b", 
    description: "A physics simulation where 100 balls collide, merge, and evolve until only one remains.",
    showOnHome: false,
  },
  {
    id: "life",
    name: "Life",
    icon: "🌄",
    color: "#0f766e",
    description: "Everything outside the terminal",
    children: ["gopro", "gallery", "map"],
    showOnHome: true,
  },
  {
    id: "gopro",
    name: "GoPro",
    icon: "Video",
    color: "#0b0b0b",
    description: "Adventures, shot from the helmet",
    showOnHome: true,
    isPopular: true,
  },
  {
    id: "gallery",
    name: "Gallery",
    icon: "Image",
    color: "#EA4335", // Google Red
    description: "Browse through my travel photos",
    showOnHome: false,
  },
  {
    id: "map",
    name: "Travel Map",
    icon: "🌎",
    color: "rgb(105 177 193)", // Google Yellow
    description: "See the places I've visited",
    showOnHome: false,
    isPopular: true,
  },
  {
    id: "git",
    name: "Git",
    icon: "GitBranch",
    color: "#333333", // Git dark gray
    description: "Work experience timeline",
    showOnHome: false,
    isPopular: true,
  },
  {
    id: "mistakes",
    name: "Development Mistakes",
    icon: "🪲",
    color: "#1E1E1E",
    description: "Redis is used to store in memory data",
    showOnHome: false,
    isPopular: true,
  },
  {
    id: "social",
    name: "Connect",
    icon: "Share2",
    color: "#34A853", // Google Green
    description: "Find me on social media",
    showOnHome: true,
  },
  {
    id: "resume",
    name: "Resume",
    icon: "FileText",
    color: "#9C27B0", // Purple
    description: "View my professional experience",
    showOnHome: true,
  },
  {
    id: "contact",
    name: "Contact",
    icon: "Mail",
    color: "#FF5722", // Deep Orange
    description: "Get in touch with me",
    showOnHome: true,
  },
  {
    id: "youtube",
    name: "Youtube",
    icon: "Youtube",
    color: "#FF0000",
    description: "Get in touch with me",
    showOnHome: true,
    isPopular: true,
  },
  {
    id: "privatebin",
    name: "Private Bin",
    icon: "🔒",
    color: "#2a9d8f",
    description: "Secret Messages",
    showOnHome: false,
    isPopular: true,
  },
  {
    id:"snakeladder",
    name:"Snake And Ladder",
    icon: "🎲", // Assuming you're using something like Lucide or Feather icons
    color: "rgb(3 69 165)", // Electric cyan (can change)
    description: "Snake and ladder",
    showOnHome: false,
  },
  {
    id: "redis",
    name: "Redis",
    icon: "https://www.dropbox.com/scl/fi/iti7svlyso311wsw1uv22/redis.webp?rlkey=sobvq4rmv12pfusdih8oxd0ar&st=4xm12myx&dl=0",
    color: "#1e1e1e", // Jenkins red/orange
    description: "Redis is used to store in memory data",
    showOnHome: false,
  },
  {
    id: "jenkins",
    name: "Jenkins",
    icon: "🚀",
    color: "#D24939",
    description: "Automation server and CI/CD tool",
    showOnHome: false,
  },
  {
    id: "recursive",
    name: "Recursive Explorer",
    icon: "Globe",
    color: "#0078D4", 
    description: "Just a recursive view",
    showOnHome: false,
  },
  {
    id: "app_not_installed",
    name: "Unknown Application",
    icon: "📦",
    color: "#4F46E5", 
    description: "App Not Installed",
    showOnHome: false,
  },
];

export const GALLERY_ITEMS = [
  {
    image:"https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
    id: 1,
    title: "Aquarium",
    location: "Planted Tanks",
    category: "Hobby",
    description: "A serene collection of planted aquariums where nature thrives underwater — each tank a living canvas of green, flowing life, and tranquil beauty.",
    images: [
      {
        id: "aquarium-1",
        url: "https://www.dropbox.com/scl/fi/1olzer2b7ydfyn1xfm8et/aquairum1.jpg?rlkey=x0sqib7tk7x31xhefelgwk6o7&st=ncc0tdq8&dl=0",
        caption: "Nature’s tranquility, right in my room 🌿🐠 #PlantedTank #AquascapeVibes"
      },
      {
        id: "aquarium-2",
        url: "https://www.dropbox.com/scl/fi/mjfvhh5w2vep8ewpnlxrd/aquaium2.jpg?rlkey=jebj44ox1kctv5i1m8iocfoaa&st=qslc9pc7&dl=0",
        caption: "Little jungle, big peace. My underwater garden in full bloom 🌱🌊 #AquariumLife #GreenAquascape"
      }
    ],
    thumbnailIndex: 1 // Use the first image as the thumbnail
  },
  {
    image:"https://images.unsplash.com/photo-1587135941948-670b381f08ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
    id: 2,
    title: "Chess",
    location: "Kapan",
    category: "Hobby",
    description: "Checkmate!!",
    images: [
      {
        id: "chess-1",
        url: "https://www.dropbox.com/scl/fi/ovrlwizv9rep30rn1qvag/chess-board-victory.jpg?rlkey=fdrawtaohiq67id7zxxnvag6l&st=eciuzvkj&dl=0",
        caption: "Every move tells a story — welcome to the chess battlefield"
      },
      {
        id: "chess-2",
        url: "https://www.dropbox.com/scl/fi/hesu1wmr2c4chv70o8w45/chess-game-2.jpg?rlkey=bt14jz720fvecftnchgxdn5qk&st=msdsfeak&dl=0",
        caption: "In chess, patience is as important as strategy"
      },
      {
        id: "chess-3",
        url: "https://www.dropbox.com/scl/fi/zy5csfesvo7volk0pz6m4/chess-screen-shot.jpg?rlkey=8psj2dz9fhiakvmpzzeyhi2cd&st=0hzgd0md&dl=0",
        caption: "A game of kings, a battle of minds"
      }
    ],
    thumbnailIndex: 0
  }
];

export const WORK_HISTORY = [
  {
    id: "job-1",
    role: "Software Development Engineer",
    company: "BookMyShow South East Asia",
    period: "April 2021 - Present",
    branch: "main",
    type: "job",
    commitDate: "2021-04-01",
    achievements: [
      "Collaborated closely with the product team to gather requirements, ensuring alignment with business objectives and user needs.",
      "Implemented E-ticketing systems and performed data migration, ensuring a seamless transition between existing and new data structure.",
      "Optimized software performance, improving overall system efficiency across multiple services.",
      "Maintained and refactored codebases across microservices, ensuring scalability and maintainability of the system.",
      "Led countless hotfixes, ensuring quick resolution of critical issues during high-demand periods, always ready to assist in keeping the system operational.",
      "Collaborated with the SKIDATA team to lead the integration process, facilitating smooth ticket synchronization to Access Control Systems (ACS).",
      "Improved large seat SVG publishing across the inventory for better visual seat selection.",
      "Served as Scrum Master for effective team coordination."
    ]
  },
  {
    id: "job-2",
    role: "Software Consultant",
    company: "ASZ Technologies",
    period: "November 2019 - March 2021",
    branch: "asz-dev",
    type: "job",
    commitDate: "2019-11-01",
    achievements: [
      "Developed a module that allowed users to watch online streaming sessions, restricting access from multiple screens.",
      "Planned and built a suppressible E-ticket module enabling users to access tickets via the website.",
      "Coordinated with the product owner on development timelines and project scope."
    ]
  },
  {
    id: "job-3",
    role: "Backend Developer",
    company: "Leaf Innovation Pvt. Ltd",
    period: "May 2019 - November 2019",
    branch: "leaf-dev",
    type: "job",
    commitDate: "2019-05-01",
    achievements: [
      "Developed a product that provides operation managers on demand.",
      "Created a search algorithm to find the best available rangers.",
      "Designed a notification module to send alerts to admins and rangers.",
      "Worked on architectural design to enhance system efficiency."
    ]
  },
  {
    id: "job-4",
    role: "Intern",
    company: "Zibtek",
    period: "January 2019 - April 2019",
    branch: "intern",
    type: "job",
    commitDate: "2019-01-01",
    achievements: [
      "Participated in developing a sales product.",
      "Assisted in sprint planning activities to ensure timely delivery of project milestones."
    ]
  },
  {
    id: "job-5",
    role: "Junior Software Developer",
    company: "Proactive Web Developers",
    period: "July 2016 - December 2018",
    branch: "proactive-dev",
    type: "job",
    commitDate: "2016-07-01",
    achievements: [
      "Developed web applications for monitoring projects of the House Building Unit, Government of Nepal.",
      "Developed frontend features using jQuery and Vue.js for various client-side functionalities.",
      "Created APIs for Android applications (Deaf Nepal NSL Learning).",
      "Designed databases and developed backend systems for the Ministry of Home Affairs website.",
      "Developed reporting systems for earthquake reconstruction (Central Level Project Implementation Unit, Grant Management, and Local Infrastructure)."
    ]
  }
];

export const EDUCATION_HISTORY = [
  {
    id: "edu-1",
    degree: "Master of Computer Applications",
    institution: "VTU, Bangalore",
    period: "2017 - 2019",
    branch: "education",
    type: "education",
    commitDate: "2017-01-01"
  },
  {
    id: "edu-2",
    degree: "Bachelor of Computer Information Systems",
    institution: "Pokhara University, Apex College",
    period: "2011 - 2016",
    branch: "education",
    type: "education",
    commitDate: "2011-01-01"
  }
];


export const RESUME_FILE = {
  url: "https://www.dropbox.com/scl/fi/ymfaiiewbiyt2erw3nns0/Ranjan-AdhikarI_Resume.docx?rlkey=ezlnheqa3qn7c5b2upnnqc53h&st=5dyeet9e&dl=0",
  filename: "Ranjan-Adhikari_Resume.docx",
  format: "DOCX",
  updated: "August 2026",
};

export const YOUTUBE_VIDEOS = [
    "https://www.youtube.com/embed/G7A0Dzz6o6Y?si=ZPkZoYqzc3_0vqnv",
    "https://www.youtube.com/embed/oKoFYpFUnO8?si=Gh1JmRaJaEMi14g7"
]


export const PLACES_I_WENT = [
  {
    id: 1,
    location: "Dubai",
    category:"Rich people "
  },
  {
    id: 2,
    location: "India",
    category:"Different people, different vibe. "
  },
  {
    id: 3,
    location: "Singapore",
    category:"I like the hot air."
  }
];

export type AdventureMedia = {
  type: "video" | "image" | "youtube";
  src: string;
  /** Still frame shown before a video starts. Optional. */
  poster?: string;
  /** Overrides the adventure caption for this one photo/clip. Optional. */
  caption?: string;
};

export type Adventure = {
  id: string;
  title: string;
  location: string;
  date: string;
  emoji: string;
  accent: string;
  caption: string;
  stats: { label: string; value: string; unit: string }[];
  media: AdventureMedia[];
};

// ⚠️ Seeded with plausible values — replace the dates, heights and locations
// with your real ones before sharing this around.
//
// Every item in `media` becomes its own full screen in the feed, so an adventure
// can mix clips and photos freely. Three sources are supported:
//
//   { type: "video", src: "https://www.dropbox.com/scl/fi/…?dl=0" }  // Dropbox share link
//   { type: "image", src: "/resources/adventures/bungy.jpg" }        // local file
//   { type: "youtube", src: "https://www.youtube.com/embed/VIDEO_ID" }
//
// Dropbox links can be pasted exactly as Dropbox gives them to you — the app
// rewrites `dl=0` to `raw=1` so the file streams instead of opening a preview
// page. Anything missing or broken falls back to a poster card, so you can add
// media one piece at a time without the feed looking unfinished.
export const ADVENTURES: Adventure[] = [
  {
    id: "canyon-swing",
    title: "Canyon Swing",
    location: "Kushma, Gandaki",
    date: "2023",
    emoji: "🌉",
    accent: "#06B6D4",
    caption: "They count to three. They lie. They drop you on two.",
    stats: [
      { label: "DROP", value: "228", unit: "m" },
      { label: "ARC", value: "4", unit: "s" },
      { label: "SCREAMS", value: "∞", unit: "" },
    ],
    media: [
      {
        type: "video",
        src: "https://www.dropbox.com/scl/fi/in3gmco74ju2toymhymam/Swing.mp4?rlkey=3njf90tunlulib6qzx4jv5mxy&st=2nvxmxs3&dl=0",
      },
    ],
  },
  {
    id: "skydive",
    title: "Skydive",
    location: "Skydive Dubai, Palm Jumeirah",
    date: "2024",
    emoji: "🪂",
    accent: "#3B82F6",
    caption: "The door opened and my brain left the plane before I did.",
    stats: [
      { label: "ALTITUDE", value: "13,000", unit: "ft" },
      { label: "FREEFALL", value: "60", unit: "s" },
      { label: "SCREAM", value: "From the top of the lungs", unit: "" },
    ],
    media: [
      {
        type: "video",
        src: "https://www.dropbox.com/scl/fi/fvh69hxoj1knm9iljimgm/Sky-Dive.mp4?rlkey=shjc6eor5iptbtjl8rxq5thdo&st=r7o1mrb1&dl=0",
      },
    ],
  },
  {
    id: "rafting-crash",
    title: "Rafting — The Flip",
    location: "Sun Koshi",
    date: "2026",
    emoji: "🌊",
    accent: "#EF4444",
    caption: "Raft went one way. I went the other. The river had opinions.",
    stats: [
      { label: "GRADE", value: "IV", unit: "" },
      { label: "SWIM", value: "40", unit: "s" },
      { label: "RAFTS", value: "0", unit: " upright" },
    ],
    media: [
      {
        type: "video",
        src: "https://www.dropbox.com/scl/fi/v54jbbjk1nkqt14lj056a/rafting-video.mp4?rlkey=3ycnnbicw4z9r8eddcqexh6me&st=ctm1zia8&dl=0",
      },
    ],
  },
];
